import { atom } from 'jotai';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export interface IDiscoverGPTContent {
  title?: string;
  description?: string;
  question?: string;
  answer?: string;
  time?: number;
}

type DiscoverGPTContentStore = { [key: string]: IDiscoverGPTContent };

export const $DiscoverGPTContentStore = atom<DiscoverGPTContentStore>({});

export const $DiscoverGPTContent = safeAtomFamily((keyword: string) => {
  const a = atom(
    (get) => {
      const data = get($DiscoverGPTContentStore)[keyword];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, input: IDiscoverGPTContent) => {
      const old = get($DiscoverGPTContentStore);
      set($DiscoverGPTContentStore, { ...old, [keyword]: input });
    },
  );

  a.debugLabel = `$DiscoverGPTContent+${encodeURIComponent(keyword)}`;

  return a;
});
